angular.module('e360')
   .directive('countrySelect', countrySelectDirective);

var templateUrl = require('./country-select.html');

function countrySelectDirective() {
   return {
      restrict: 'E',
      require: ['^^countryStates', 'ngModel'],
      transclude: true,
      templateUrl: templateUrl,
      link: countrySelectDirectiveLink
   };

   function countrySelectDirectiveLink(scope, element, attr, ctrls) {
      var countryStatesCtrl = ctrls[0];
      var ngModelCtrl = ctrls[1];

      scope.$watch(attr.ngModel, onCountryChange);

      function onCountryChange(newVal, oldVal) {
         countryStatesCtrl.onCountryChange(newVal);
      }
   }
}
